export default __webpack_public_path__ + "static/media/trowel.acda167d.png";